import { SupplierContactsForm } from '@partials/forms/supplier-detail/supplier-contacts'

export type ISupplierContactsTab = Parameters<typeof SupplierContactsForm>[0]

export const SupplierContactsTab = ({ onError }: ISupplierContactsTab) => {
  return <SupplierContactsForm onError={onError} />
}
